import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPage: {
    [theme.breakpoints.down("xs")]: {
      height: "100vh"
    }
  },
  appPageHeader: {
    height: "initial",
    [theme.breakpoints.down("xs")]: {
      top: "0"
    }
  },
  component: {
    background: "#f6fbfa",
    position: "relative",
    width: "100%",
    height: "100%",
    flexGrow: 1
  },
  editMode: {
    "& .MuiPaper-root > div": {
      [theme.breakpoints.down("md")]: {
        opacity: "0.15"
      }
    }
  },
  grid: {
    zIndex: 0,
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse"
    },
    [theme.breakpoints.up("sm")]: {
      height: "100%"
    }
  },
  hiddenOnSm: {
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  column: {
    paddingRight: 10,
    maxHeight: "100%",
    overflow: "auto",
    paddingTop: 24,
    "&:first-child": {
      paddingLeft: 24,
      paddingRight: 10,
      [theme.breakpoints.down("sm")]: {
        display: "none"
      }
    },
    "&:last-child": {
      paddingRight: 0,
      paddingLeft: 10,
      paddingBottom: 0,
      [theme.breakpoints.up("sm")]: {
        paddingLeft: 10,
        paddingRight: 24
      },
      [theme.breakpoints.down("sm")]: {
        paddingLeft: 24,
        paddingRight: 24
      },
      [theme.breakpoints.down("xs")]: {
        paddingBottom: 0,
        paddingTop: 16,
        paddingLeft: 16,
        paddingRight: 16
      }
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      paddingLeft: 0
    },
    [theme.breakpoints.up("sm")]: {
      paddingBottom: 24
    }
  },
  progress: {
    textAlign: "center"
  },
  topBar: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 0
  },
  topBarLine: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  topBarSubtitleLine: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 40,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.down("sm")]: {
      height: 52,
      justifyContent: "space-between"
    }
  },
  topBarTitleLine: {
    height: 60
  },
  topBarTitle: {
    fontSize: 20,
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: 18
    }
  },
  topBarSubTitle: {
    fontSize: 14
  },
  topBarSubTitleLeft: {
    display: "flex",
    fontSize: 14
  },
  topBarSubTitleRight: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse"
    }
  },
  topBarSubTitleName: {
    fontSize: 14,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: 18
    }
  },
  topBarSubTitleFacility: {
    fontSize: 14,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      textAlign: "right"
    }
  },
  topBarSubTitleDate: {
    fontSize: 14,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 1,
      fontWeight: "normal",
      textAlign: "right"
    }
  },
  arrowBackLink: {
    position: "absolute",
    left: 16,
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      left: 10
    },
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  arrowBackIcon: {
    fontSize: 32
  },
  hideOnSm: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  xsPinToTop: {
    [theme.breakpoints.down("xs")]: {
      top: 0
    }
  }
}));
